import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_ADMINS,
  GET_ADMIN_DETAIL,
  ADD_NEW_ADMIN,
  UPDATE_ADMIN,
  DELETE_ADMIN,
  CHANGE_PASSWORD_ADMIN,
} from "./actionTypes"
import {
  getAdminsSuccess,
  getAdminsFail,
  getAdminDetailSuccess,
  getAdminDetailFail,
  addAdminFail,
  addAdminSuccess,
  updateAdminSuccess,
  updateAdminFail,
  deleteAdminSuccess,
  deleteAdminFail,
  changePasswordSuccess,
  changePasswordFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getAdmins,
  getAdminsDetails,
  addNewAdmin,
  updateAdmin,
  deleteAdmin,
  changePasswordAdmin,
} from "helpers/backend_helper"

function* fetchAdmins({ payload }) {
  try {
    const response = yield call(getAdmins)
    yield put(getAdminsSuccess(response))
  } catch (error) {
    yield put(getAdminsFail(error))
  }
}

function* fetchAdminDetail({ AdminId }) {
  try {
    const response = yield call(getAdminsDetails, AdminId)
    yield put(getAdminDetailSuccess(response))
  } catch (error) {
    yield put(getAdminDetailFail(error))
  }
}

function* onUpdateAdmin({ payload: Admin }) {
  try {
    const response = yield call(updateAdmin, Admin)
    if (response?.success) {
      yield put(updateAdminSuccess(response))
    } else {
      yield put(updateAdminFail(response?.message))
    }
  } catch (error) {
    yield put(updateAdminFail(error))
  }
}

function* onAddNewAdmin({ payload: Admin }) {
  try {
    const response = yield call(addNewAdmin, Admin)
    if (response?.success) {
      yield put(addAdminSuccess(response))
    } else {
      yield put(addAdminFail(response))
    }
  } catch (error) {
    yield put(addAdminFail(error))
  }
}

function* onDeleteAdmin({ payload: Admin }) {
  try {
    const response = yield call(deleteAdmin, Admin)
    if (response?.success) {
      yield put(deleteAdminSuccess(Admin))
    } else {
      yield put(deleteAdminFail(response?.message))
    }
  } catch (error) {
    yield put(deleteAdminFail(error))
  }
}

function* onChangePasswordAdmin({ payload: Admin }) {
  try {
    const response = yield call(changePasswordAdmin, Admin)
    if (response?.success) {
      yield put(changePasswordSuccess(response))
    } else {
      yield put(changePasswordFail(response))
    }
  } catch (error) {
    yield put(changePasswordFail(error))
  }
}

function* AdminsSaga() {
  yield takeEvery(GET_ADMINS, fetchAdmins)
  yield takeEvery(GET_ADMIN_DETAIL, fetchAdminDetail)
  yield takeEvery(ADD_NEW_ADMIN, onAddNewAdmin)
  yield takeEvery(UPDATE_ADMIN, onUpdateAdmin)
  yield takeEvery(DELETE_ADMIN, onDeleteAdmin)
  yield takeEvery(CHANGE_PASSWORD_ADMIN, onChangePasswordAdmin)
}

export default AdminsSaga
